import PageShell from '@/components/feature/PageShell';
import ServicesIntro from './components/ServicesIntro';
import ServiceModules from './components/ServiceModules';
import ProcessAndCta from './components/ProcessAndCta';

export default function Services() {
  return (
    <PageShell
      title="Services | Talent Acquisition & HR Advisory | Morrow People"
      description="Talent acquisition, HR advisory and people & organisation services from Morrow People — designed around real business challenges and long-term outcomes."
    >
      <ServicesIntro />
      <ServiceModules />
      <ProcessAndCta />
    </PageShell>
  );
}